<svg:polyline
  *ngFor="let connection of connections$ | async; trackBy: trackByIndex"
  [attr.points]="connection.pointString"
  [style.stroke]="connection.color"
  (mousedown)="handleMouseEvent($event, 'shape')"
  (dblclick)="handleMouseEvent($event, 'shape')"
  (mouseup)="handleMouseEvent($event, 'shape')"
/>
<svg:g
  *ngFor="let subpointInfo of allSubpointInfo$ | async; trackBy: trackByIndex"
  [h3Subpoint]="subpointInfo"
  [shapeSelected]="selected"
  (mousedown)="handleMouseEvent($event, 'subpoint', subpointInfo.subpointIndex)"
  (dblclick)="handleMouseEvent($event, 'shape')"
  (mouseup)="handleMouseEvent($event, 'shape')"
/>
